import React from 'react'
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { FileUpload } from 'primereact/fileupload';
import {ScrollPanel} from 'primereact/scrollpanel';

import servicioArchivo from '../servicios/ServicioArchivos';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioEmisor from '../servicios/ServicioEmisor';

export class Emisor extends React.Component {

    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            mostrarFormulario: false,
            mostrarMensaje: false,
            modalEditarInformacionEmisor: false,
            modalEditarCertificados: false,
            errores: {},
            emisor: {},
            accion: null

        }
    }

    componentDidMount() {
        this.obtenerPagina();
    }

    cambiaPagina = (event) => {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }

    obtenerPagina = () => {
        let { paginacion } = this.state;
        servicioEmisor.paginacion(paginacion).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }

    resetEstados = () => {
        this.setState({ mostrarFormulario: false, errores: {}, emisor: {}, mostrarMensaje: false })

    }

    cerrarModalConfirmacion = () => {
        this.setState({ mostrarMensaje: false })
    }

    asignarValores = (event) => {
        if (event.target.id === 'clave')
            servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
        else
            servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    }

    validarFormulario = (objeto) => {
        const errores = {};
        let patron = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]{3}$/;

        if (!objeto.regimenFiscal)
            errores.regimenFiscal = "El campo es requerido";
        if (!objeto.nombre)
            errores.nombre = "El campo es requerido";
        if (!objeto.domicilio)
            errores.domicilio = "El campo es requerido";
        if (!objeto.codigoPostal)
            errores.codigoPostal = "El codigo postal es requerido";
        if (!objeto.rfc)
            errores.rfc = "El campo es requerido";
        if (!patron.test(objeto.rfc)) {
            this.growl.show({ life: 7000, severity: 'error', summary: '', detail: 'El RFC no cumple con un patrón válido.  Ejemplo: Persona Física AAAA010101AAA, Persona Moral AAA010101AAA' });
            errores.rfc = "El rfc es inválido";
        }
        if (!objeto.claveCsd)
            errores.claveCsd = "El campo es requerido";
        if (!objeto.cerCsd)
            errores.cerCsd = "El campo es requerido";
        if (!objeto.keyCsd)
            errores.keyCsd = "El campo es requerido";
        return errores;
    }

    nuevoEmisor = () => {
        this.setState({ mostrarFormulario: true, emisor: {}, errores: {} });
    }

    mostrarFormulario = (rowData) => {
        this.setState({ modalEditarInformacionEmisor: true, emisor: rowData });
    }



    mostrarMensaje = (rowData) => {
        this.setState({ mostrarMensaje: true, accion: 'eliminar', rowData: rowData })
    }

    accion = () => {
        let { emisor } = this.state;

        const resultadoValidacion = this.validarFormulario(emisor);

        this.setState({ errores: resultadoValidacion });

        if (!Object.keys(resultadoValidacion).length) {
            this.setState({ mostrarMensaje: true })
        }
    }

    aceptar = () => {
        this.guardar();

    }

    guardar = () => {
        let { emisor } = this.state;
        servicioEmisor.guardar(emisor).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false) {
                this.resetEstados();
                this.obtenerPagina();

            }
        }).catch((error) => {

        })
    }

    editar = () => {
        let { emisor } = this.state;
        servicioEmisor.editar(emisor).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false) {
                this.resetEstados();
                this.obtenerPagina();
            }
        }).catch((error) => {

        })
    }

    plantillaOpciones = (rowData) => {
        return <div className="p-grid" style={{justifyContent:'center'}}>

            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-edit" className="p-button-warning" name="editar"
                    tooltip="editar información" onClick={this.mostrarFormulario.bind(this, rowData)} >
                </Button>
            </div>
        </div>
    }

    columnaEditarCertificados = (rowData) => {
        return <div className="p-grid" style={{justifyContent:'center'}}>
            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-edit" className="p-button-warning" name="editar"
                    tooltip="editar certificados" onClick={this.mostrarFormularioCertificados.bind(this, rowData)} >
                </Button>
            </div>
        </div>
    }

    leerCer = (event) => {
        let { emisor } = this.state;
        servicioArchivo.obtenerBytesBase64StringArchivo(event.files[0], emisor, 'cerCsd');
        this.setState(emisor);
        this.growl.show({ life: 5000, severity: 'success', summary: 'Success', detail: 'El certificado se cargo con éxito' });
    }

    leerKey = (event) => {
        let { emisor } = this.state;
        servicioArchivo.obtenerBytesBase64StringArchivo(event.files[0], emisor, 'keyCsd');
        this.setState(emisor);
        this.growl.show({ life: 5000, severity: 'success', summary: 'Success', detail: 'El certificado privado se cargo con éxito' });
    }

    editarInformaiconEmisor = () => {
        let { emisor } = this.state;
        const resultadoValidacion = this.validarFormularioInformacionEmisor(emisor);
        this.setState({ errores: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            servicioEmisor.editarInformacionEmisor(emisor).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false) {
                    this.setState({ modalEditarInformacionEmisor: false, emisor: {} });
                    this.obtenerPagina();
                }


            })
        }
    }

    cerrarModalEditarInformacion = () => {
        this.setState({ modalEditarInformacionEmisor: false, emisor: {} });
    }

    validarFormularioInformacionEmisor = (objeto) => {
        const errores = {};
        let patron = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]{3}$/;

        if (!objeto.regimenFiscal)
            errores.regimenFiscal = "El campo es requerido";
        if (!objeto.nombre)
            errores.nombre = "El campo es requerido";
        if (!objeto.domicilio)
            errores.domicilio = "El campo es requerido";
        if(!objeto.codigoPostal)
        errores.codigoPostal="El codigo postal es requerido";
        if (!objeto.rfc)
            errores.rfc = "El campo es requerido";
        if (!patron.test(objeto.rfc)) {
            this.growl.show({ life: 7000, severity: 'error', summary: '', detail: 'El RFC no cumple con un patrón válido.  Ejemplo: Persona Física AAAA010101AAA, Persona Moral AAA010101AAA' });
            errores.rfc = "El rfc es inválido";
        }
        return errores;
    }

    mostrarFormularioCertificados = (rowData) => {
        this.setState({ modalEditarCertificados: true, emisor: rowData });
    }

    editarCertificadosEmisor = () => {
        let { emisor } = this.state;
        const resultadoValidacion = this.validarFormularioCertificadosEmisor(emisor);
        this.setState({ errores: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            servicioEmisor.editarCertificadosEmisor(emisor).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false) {
                    this.setState({ modalEditarCertificados: false, emisor: {} });
                    this.obtenerPagina();
                }


            })
        }
    }

    validarFormularioCertificadosEmisor = (objeto) => {
        const errores = {};
        let patron = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]{3}$/;

        if (!objeto.rfc)
            errores.rfc = "El campo es requerido";
        if (!patron.test(objeto.rfc)) {
            this.growl.show({ life: 7000, severity: 'error', summary: '', detail: 'El RFC no cumple con un patrón válido.  Ejemplo: Persona Física AAAA010101AAA, Persona Moral AAA010101AAA' });
            errores.rfc = "El rfc es inválido";
        }
        if (!objeto.claveCsd)
            errores.claveCsd = "El campo es requerido";
        if (!objeto.cerCsd)
            errores.cerCsd = "El campo es requerido";
        if (!objeto.keyCsd)
            errores.keyCsd = "El campo es requerido";
        return errores;
    }

    cerrarModalCertificadosEmisor = () => {
        this.setState({ modalEditarCertificados: false, emisor: {} });
    }
    render() {

        let { emisor, errores, paginacion, inicio } = this.state;

        const pieFormulario = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Aceptar" icon="pi-md-check" onClick={this.accion.bind(this)} />
            <Button label="Cancelar" icon="pi-md-close" className="p-button-danger " onClick={this.resetEstados} />
        </div>;

        const pieMensaje = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Aceptar" icon="pi-md-check" onClick={this.aceptar.bind(this)} />
            <Button label="Cancelar" icon="pi-md-close" className="p-button-danger " onClick={this.cerrarModalConfirmacion} />
        </div>;

        const pieModalEditarInformacionEmisor = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Aceptar" icon="pi-md-check" onClick={this.editarInformaiconEmisor} />
            <Button label="Cancelar" icon="pi-md-close" className="p-button-danger " onClick={this.cerrarModalEditarInformacion} /></div>

        const pieModalEditarCertificados = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Aceptar" icon="pi-md-check" onClick={this.editarCertificadosEmisor} />
            <Button label="Cancelar" icon="pi-md-close" className="p-button-danger " onClick={this.cerrarModalCertificadosEmisor} /></div>


        return (
            <div className="container">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">

                    <div className="p-col-12">
                        <div className="card card-w-title">
                            <h1 style={{marginBottom:'30px'}}>Administración de Emisores</h1>
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-12" style={{width:'285px'}}>
                                    <Button className="blue-grey-btn flat-btn" label="Nuevo Emisor" tooltip={"Agregar nuevo"} onClick={this.nuevoEmisor} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12">
                        <Dialog visible={this.state.mostrarFormulario} style={{ width: '60%' }} header="Datos del emisor" modal={true} footer={pieFormulario} onHide={this.resetEstados}>
                        <ScrollPanel style={{width: '100%', height: '300px'}}>
                            <h4>Los campos con (*) son obligatorios, por favor captura los datos del emisor</h4>
                            <div className="p-grid">

                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">account_balance</i></span>
                                        <InputText placeholder="* RFC" maxLength={13} id="rfc" name="emisor.rfc" className={errores.rfc ? 'p-error' : ''} value={emisor.rfc || ''}
                                            onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.rfc ? <div><br /> <Message severity="error" text={errores.rfc} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">work</i></span>
                                        <InputText placeholder="* Régimen fiscal" maxLength={3} id="regimen" name="emisor.regimenFiscal" className={errores.regimenFiscal ? 'p-error' : ''} value={emisor.regimenFiscal || ''}
                                            keyfilter="int" tooltip="Ingresa la clave del régimen a la que perteneces" onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.regimenFiscal ? <div><br /> <Message severity="error" text={errores.regimenFiscal} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">account_box</i></span>
                                        <InputText placeholder="* Razón Social" id="razon" name="emisor.nombre" className={errores.nombre ? 'p-error' : ''} value={emisor.nombre || ''}
                                            onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">home</i></span>
                                        <InputText placeholder="* Domicilio" id="domicilio" name="emisor.domicilio" className={errores.domicilio ? 'p-error' : ''} value={emisor.domicilio || ''}
                                            tooltip="Ingresa tu domicilio" onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.domicilio ? <div><br /> <Message severity="error" text={errores.domicilio} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">home</i></span>
                                        <InputText placeholder="* Codigo postal" id="postal" name="emisor.codigoPostal" className={errores.codigoPostal ? 'p-error' : ''} value={emisor.codigoPostal || ''}
                                            tooltip="Ingresa codigo postal" onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.domicilio ? <div><br /> <Message severity="error" text={errores.codigoPostal} /> </div> : null}
                                </div>


                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"> <label htmlFor="cer">*Archivo CSD</label></span>
                                        <FileUpload mode="basic" name="emisor.cerCsd" className={errores.cerCsd ? 'p-error' : ''} value={emisor.cerCsd || ''}
                                            chooseLabel=".cer" onSelect={this.leerCer} accept=".cer" auto={true} />

                                    </div>
                                    {errores.cerCsd ? <div><br /> <Message severity="error" text={errores.cerCsd} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"> <label htmlFor="key">*Archivo Key</label></span>
                                        <FileUpload mode="basic" name="emisor.keyCsd" className={errores.keyCsd ? 'p-error' : ''} value={emisor.keyCsd || ''}
                                            chooseLabel=".key" onSelect={this.leerKey} accept=".key" auto={true} />
                                    </div>
                                    {errores.keyCsd ? <div><br /> <Message severity="error" text={errores.keyCsd} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">vpn_key</i></span>
                                        <InputText placeholder="* Clave CSD" id="clave" name="emisor.claveCsd" className={errores.claveCsd ? 'p-error' : ''} value={emisor.claveCsd || ''}
                                            onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.claveCsd ? <div><br /> <Message severity="error" text={errores.claveCsd} /> </div> : null}
                                </div>

                            </div>
                            </ScrollPanel>
                        </Dialog>
                    </div>

                    <div className="p-col-12">
                        <div className="card card-w-title">
                            <DataTable value={paginacion.datos} editable={true} selectionMode="single" responsive={true} header="MIS EMISORES" >
                                <Column field="rfc" header="RFC" autoLayout={true} style={{textAlign:'center'}}/>
                                <Column field="nombre" header="Nombre" autoLayout={true} style={{textAlign:'center'}}/>
                                <Column field="regimenFiscal" header="Régimen Fiscal" autoLayout={true} style={{textAlign:'center'}}/>
                                
                                <Column header="Editar Información" body={this.plantillaOpciones.bind(this)} filter={false} autoLayout={true} style={{textAlign:'center'}}/>
                                <Column header="Editar Certificados" body={this.columnaEditarCertificados.bind(this)} filter={false} autoLayout={true} style={{textAlign:'center'}}/>
                                
                            </DataTable>
                            <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                        </div>
                    </div>

                    <div className="p-col-12">
                        <Dialog visible={this.state.mostrarMensaje} style={{ width: '30%' }} modal={true} header="Confirmación" footer={pieMensaje} onHide={this.cerrarModalConfirmacion}>
                            <center><h4>¿Estas seguro?</h4></center>
                        </Dialog>
                    </div>

                    <div className="p-col-12">
                        <Dialog visible={this.state.modalEditarInformacionEmisor} style={{ width: '60%' }} modal={true} header="Datos del emisor" footer={pieModalEditarInformacionEmisor} onHide={this.cerrarModalEditarInformacion}>
                        <ScrollPanel style={{width: '100%', height: '300px'}}>
                            <h4>Los campos con (*) son obligatorios, por favor captura los datos del emisor</h4>
                            <div className="p-grid">

                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">account_balance</i></span>
                                        <InputText placeholder="* RFC" maxLength={13} id="rfc" name="emisor.rfc" className={errores.rfc ? 'p-error' : ''} value={emisor.rfc || ''}
                                            onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.rfc ? <div><br /> <Message severity="error" text={errores.rfc} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">work</i></span>
                                        <InputText placeholder="* Régimen fiscal" maxLength={3} id="regimen" name="emisor.regimenFiscal" className={errores.regimenFiscal ? 'p-error' : ''} value={emisor.regimenFiscal || ''}
                                            keyfilter="int" tooltip="Ingresa la clave del régimen a la que perteneces" onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.regimenFiscal ? <div><br /> <Message severity="error" text={errores.regimenFiscal} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">account_box</i></span>
                                        <InputText placeholder="* Razón Social" id="razon" name="emisor.nombre" className={errores.nombre ? 'p-error' : ''} value={emisor.nombre || ''}
                                            onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">home</i></span>
                                        <InputText placeholder="* Domicilio" id="domicilio" name="emisor.domicilio" className={errores.domicilio ? 'p-error' : ''} value={emisor.domicilio || ''}
                                            tooltip="Ingresa tu domicilio" onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.domicilio ? <div><br /> <Message severity="error" text={errores.domicilio} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-12">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">home</i></span>
                                        <InputText placeholder="* Codigo Postal" id="codigoPostal" name="emisor.codigoPostal" className={errores.codigoPostal ? 'p-error' : ''} value={emisor.codigoPostal || ''}
                                            tooltip="Ingresa codigo postal" onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.codigoPostal ? <div><br /> <Message severity="error" text={errores.codigoPostal} /> </div> : null}
                                </div>
                            </div>
                            </ScrollPanel>
                        </Dialog>

                    </div>
                    <div className="p-col-12">
                        <Dialog visible={this.state.modalEditarCertificados} style={{ width: '60%' }} header="Datos del emisor" modal={true} footer={pieModalEditarCertificados} onHide={this.cerrarModalCertificadosEmisor}>
                        <ScrollPanel style={{width: '100%', height: '300px'}}>
                            <h4>Los campos con (*) son obligatorios, por favor captura los datos del emisor</h4>
                            <div className="p-grid">

                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">account_balance</i></span>
                                        <InputText placeholder="* RFC" maxLength={13} id="rfc" name="emisor.rfc" className={errores.rfc ? 'p-error' : ''} value={emisor.rfc || ''}
                                            onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.rfc ? <div><br /> <Message severity="error" text={errores.rfc} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"> <label htmlFor="cer">*Archivo CSD</label></span>
                                        <FileUpload mode="basic" name="emisor.cerCsd" className={errores.cerCsd ? 'p-error' : ''} value={emisor.cerCsd || ''}
                                            chooseLabel=".cer" onSelect={this.leerCer} accept=".cer" auto={true} />

                                    </div>
                                    {errores.cerCsd ? <div><br /> <Message severity="error" text={errores.cerCsd} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"> <label htmlFor="key">*Archivo Key</label></span>
                                        <FileUpload mode="basic" name="emisor.keyCsd" className={errores.keyCsd ? 'p-error' : ''} value={emisor.keyCsd || ''}
                                            chooseLabel=".key" onSelect={this.leerKey} accept=".key" auto={true} />
                                    </div>
                                    {errores.keyCsd ? <div><br /> <Message severity="error" text={errores.keyCsd} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">vpn_key</i></span>
                                        <InputText placeholder="* Clave CSD" id="clave" name="emisor.claveCsd" className={errores.claveCsd ? 'p-error' : ''} value={emisor.claveCsd || ''}
                                            onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.claveCsd ? <div><br /> <Message severity="error" text={errores.claveCsd} /> </div> : null}
                                </div>

                            </div>
                            </ScrollPanel>
                        </Dialog>
                    </div>
                </div>
            </div>
        );
    }

}